/* eslint-disable */
import { useContext, useEffect, useState } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { Box, Button, Grid, TextField } from '@material-ui/core';
import useApp from '../../../hooks/useApp';
import filterStyles from '../../filterStyles/index';

// const statusList = [
//   { name: 'Atendida', value: 'ANSWERED' },
//   { name: 'Não atendida', value: 'NO ANSWER' },
//   { name: 'Ocupado', value: 'BUSY' },
//   { name: 'Falha', value: 'FAILED' },
// ];

const DatePeriodFilter = ({ setFilters }) => {
  const classes = filterStyles();
  const { partners, indicator } = useApp();

  const [partner, setPartners] = useState();
  const [leadNum, setLeadNum] = useState();
  const [userLogin, setUserLogin] = useState();

  function handleSubmit(event) {
    event.preventDefault();

    let filters = {
      partner: partner?.code_wf || null,
      leadNum: leadNum || null,
      userLogin: userLogin || null,
    };
    setFilters((f) => ({ ...f, ...filters }));
  }

  const handleChange = (e, value) => {
    e.preventDefault();

    setUserLogin(value?.login?.toUpperCase());
  };

  return (
    <Box className={classes.boxFilter}>
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <Grid container spacing={2} alignItems="center">
          <Grid container item xs={12} md={12} alignItems="center" spacing={2}>
            <Grid item xs={12} md={3}>
              <Autocomplete
                // multiple
                options={partners}
                className={classes.inputSelect}
                getOptionLabel={(option) => option?.name}
                onChange={(e, value) => setPartners(value)}
                renderInput={(params) => (
                  <TextField {...params} variant="standard" fullWidth placeholder="Concessionária" />
                )}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <TextField
                value={leadNum}
                type="number"
                className={classes.inputSelect}
                variant="standard"
                placeholder="Num. Proposta"
                onChange={(e, value) => setLeadNum(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <Autocomplete
                // multiple
                options={indicator || []}
                className={classes.inputSelect}
                getOptionLabel={(option) => option?.name}
                onChange={(e, value) => handleChange(e, value)}
                renderInput={(params) => <TextField {...params} variant="standard" fullWidth placeholder="Indicador" />}
              />
            </Grid>

            <Grid item>
              <Button fullWidth className={classes.button} type="submit">
                Filtrar
              </Button>
            </Grid>

            <Grid item xs={12} style={{ fontSize: '14px', color: '#838383'}}>
              * Selecione ao menos duas opções de filtro!
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default DatePeriodFilter;
